<template>
  <form class="col-12 b-form b-dialog__form">
    <server-error class="mb-4" :error="error" />
    <CreateAssetWidget @closeDialog="closeDialog" :assetForm="asset" @saveAsset="onSaveAsset($event)"></CreateAssetWidget>
  </form>
</template>

<script>
	import CreateAssetWidget from "../../../widgets/CreateAssetWidget";

	export default {
		components: {
			CreateAssetWidget,
		},
    props: {
			asset: {
				default: null,
			}
    },
		data() {
			return {
				error: null,
			}
		},
		methods: {
			async onSaveAsset(data) {
				try {
					this.error = null;
          if (!data.businessUnitId) {
            if (data.businessUnitName || data.businessUnitExternalId) {
              const newBusinessUnit = await this.$store.dispatch('createBusinessUnit', [data.businessUnitName, data.businessUnitExternalId]);
              data.businessUnitId = newBusinessUnit.idInDB;
            }
          }
          this.closeDialog();
          this.$fileLoadingManager.startLoading();
					if (!data.idInDB) {
						await this.$store.dispatch('createAsset', Object.assign({}, data));
					} else {
						await this.$store.dispatch('updateAsset', Object.assign({}, data));
					}
				} catch (e) {
					this.error = e;
				}
        finally {
          this.$fileLoadingManager.finishLoading();
        }
			},
			closeDialog() {
				this.$emit('closeDialog');
			}
		}
	}
</script>
